/**
 * Module dependencies.
 */

import { Tag } from 'antd';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  status: string;
};

/**
 * Status color mapping.
 */

function getStatusColor(status: string): string {
  const statusCode = parseInt(status, 10);

  if (statusCode >= 200 && statusCode < 300) {
    return 'green';
  }

  if (statusCode >= 300 && statusCode < 400) {
    return 'blue';
  }

  if (statusCode >= 400 && statusCode < 500) {
    return 'orange';
  }

  if (statusCode >= 500) {
    return 'red';
  }

  return 'default';
}

/**
 * Export `TherapyStatusRenderer` component.
 */

export function TherapyStatusRenderer({ status }: Props): JSX.Element {
  const color = getStatusColor(status);

  return (
    <Tag color={color} style={{ fontSize: '13px', fontWeight: 'bold' }}>
      {status}
    </Tag>
  );
}
